import styled from "styled-components";

export const GameNavBarButtonLabelDefaultBox = styled.div<{smallSize?: boolean;}>`
    text-align: center;
    font-size: ${props => props.smallSize ? 9 : 10}px;
    line-height: 12px;
    padding-top: 6px;
`;
